export default __webpack_public_path__ + "static/media/tlm-white.27ecfc4a.png";